import { render } from "@/components/pages/dataRecollection/workSupport/dataMonitor/DataMonitorMeasure.html?vue&type=template&id=6f77e764&scoped=true&external"
import script from "@/components/pages/dataRecollection/workSupport/dataMonitor/DataMonitorMeasure.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/workSupport/dataMonitor/DataMonitorMeasure.js?vue&type=script&lang=js&external"

import "@/components/pages/dataRecollection/workSupport/dataMonitor/DataMonitorMeasure.scss?vue&type=style&index=0&id=6f77e764&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f77e764"]])

export default __exports__